"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("components/cosmos/toast/constants");
const translationContext_1 = require("configs/translationContext");
const ui_1 = require("modules/ui");
const constants_2 = require("../constants");
const stores_1 = require("../stores");
const useBulkRequest = () => {
    const { t } = (0, translationContext_1.useTranslation)();
    const captureException = async ({ onSuccess }) => {
        try {
            await onSuccess();
            stores_1.BulkDrippingStore.setActionInProgress(true);
        }
        catch (error) {
            const { data } = error.response || error;
            let message = t('alerts.error_try_again');
            if ((data === null || data === void 0 ? void 0 : data.errorCode) ===
                constants_2.EndpointErrors.AnotherDrippingBulkOperationInProgress) {
                message = t('dripping_2.notifications.wait_for_completion');
            }
            else if ((data === null || data === void 0 ? void 0 : data.errorCode) === constants_2.EndpointErrors.InvalidContentType) {
                message = t('dripping_2.notifications.invalid_content_type');
            }
            stores_1.BulkDrippingStore.resetAction();
            ui_1.UiService.setAlertWithText({ message, type: constants_1.TOAST_TYPE.danger });
        }
    };
    return { captureException };
};
exports.default = useBulkRequest;
